import { SimpleFormSelectOption } from "src/app/components/form/SimpleFormSelect";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { TemplatesTransport } from "src/app/transports/templates";
import { LangType } from "src/app/types/LangType";
import { TagType } from "src/app/types/Message";

const useAvailableTagsOptions = (
    defaultLang: LangType,
    addCurrentTag?: TagType | null,
    inicialRequest = true
) => {
    const { formatMessage } = useIntl();

    const [tagsOptions, setTagsOptions] = useState<Array<SimpleFormSelectOption>>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();

    const fetch = (lang: LangType) => {
        setLoading(true);
        TemplatesTransport.findAvailableTags(lang)
            .then((res) =>
                setTagsOptions(() => {
                    const newTags = res.map((el) => ({
                        value: el,
                        label: formatMessage({ id: `common.field.tagType.${el}` }),
                    }));
                    if (addCurrentTag)
                        newTags.push({
                            value: addCurrentTag,
                            label: formatMessage({ id: `common.field.tagType.${addCurrentTag}` }),
                        });
                    return newTags;
                })
            )
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    };
    const refresh = (lang: LangType) => {
        if (!loading) fetch(lang);
    };

    useEffect(() => {
        if (inicialRequest) fetch(defaultLang);
    }, []);

    return { tagsOptions, refresh, loading, error };
};

export default useAvailableTagsOptions;
